import { render, staticRenderFns } from "./WebARModels.vue?vue&type=template&id=6831888f&"
import script from "./WebARModels.vue?vue&type=script&lang=js&"
export * from "./WebARModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports